<template lang="pug">
  div
    div(class="d-flex align-center")
      v-btn(
        class="main-button mr-4"
        @click="createNewPeriod('tariff')"
      ) {{ $t('Activate premium') }}
      v-btn(
        class="secondary-button"
        @click="createNewPeriod('bonus')"
      ) {{ $t('Add sorry bonus') }}
    m-table(
      store-name="billing"
      :query-filter="queryFilter"
      :headers="headers"
      ref="table"
    )
</template>

<script>
import MTable from '~/components/modules/tables/m-table'
import contentDialogContentTop from '~/mixins/dialogs/contentDialogContentTop'

export default {
  name: 'BlockOrganizationBilling',
  components: { MTable },
  mixins: [contentDialogContentTop],
  props: {
    organizationId: {
      type: String,
      default: null
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Tariff name',
          value: 'tariff.name',
          sortable: false,
          filterable: false
        },
        {
          text: 'Organization name',
          value: 'organizationName',
          sortable: false,
          filterable: false
        },
        {
          text: 'Edrpou',
          value: 'organizationCode',
          sortable: false,
          filterable: false
        },
        {
          text: 'Balance, ₴',
          valueFormatter: billing => (billing.balance / 100).toFixed(2),
          sortable: false,
          filterable: false
        },
        {
          text: 'Payer code',
          value: 'payerCode',
          sortable: false,
          filterable: false
        }
      ]
    },
    queryFilter() {
      return {
        'organization.id': this.organizationId
      }
    }
  },
  methods: {
    createNewPeriod(type) {
      this.contentDialogContentTop.open({
        width: '512px',
        component: 'm-form-block',
        componentProps: {
          buttonText: this.$t('Activate access'),
          successMessage: this.$t('Now organization has access for premium'),
          fields: [
            {
              model: 'months',
              component: 'v-select',
              provider: {},
              attrs: {
                filled: true,
                label: this.$t('Select months count'),
                items: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                menuProps: { bottom: true, offsetY: true }
              },
              fieldVal: () => 1
            },
            {
              model: 'tariffId',
              component: 'v-select',
              provider: {
                vid: 'tariffId',
                name: 'Tariff',
                rules: 'required'
              },
              request: async () => {
                const { data } = await this.$store.dispatch('admintariffs/getAll')
                return this._.map(data, tariff => ({ text: tariff.name, value: tariff.id }))
              },
              attrs: {
                filled: true,
                label: this.$t('Select tariff'),
                menuProps: { bottom: true, offsetY: true },
                visible: () => type === 'tariff'
              }
            },
            {
              model: 'documents',
              component: 'v-text-field',
              provider: {
                vid: 'documents',
                name: 'Documents count',
                rules: 'required|integer|min:1'
              },
              attrs: {
                type: 'number',
                filled: true,
                label: this.$t('Documents count'),
                visible: () => type === 'bonus'
              }
            }
          ],
          onSubmit: async form => {
            await this.$store.dispatch('billing/adminCreatePeriod', {
              type,
              ...form,
              documents: type === 'bonus' ? Number(form.documents) : null,
              organizationId: this.organizationId
            })
            if (this.$refs.table && this._.isFunction(this.$refs.table.fetchData)) {
              await this.$refs.table.fetchData()
            }
            this.contentDialogContentTop.close()
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
